(() => {
	angular
		.module('main')
		.controller('PaymentMethodsController', PaymentMethodsController);

	PaymentMethodsController.$inject = [];

	function PaymentMethodsController() {}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/paymentMethodsController.js